<template>
  <div class="main-wrapper">
    <import-task ref="importTask">
      <template slot="header">
        <search-box class="search-box">
          <el-form :inline="true" size="mini">
            <el-form-item label="日期">
              <form-date-range :form="form" startKey="startDate" :usingTime="false" endKey="endDateStr" valueFormat="yyyy-MM-dd HH:mm:ss"></form-date-range>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          </template>
        </search-box>
      </template>
      <template slot="main-header">
        <div class="btn-right">
          <span class="btn-green" @click="isShowImportRecords = true" v-permission="'ec-pc-new$dataImport$preSalePlan$subMonthAdjust$timeoutImport'">超时导入记录</span>
          <report-info v-if="isMonthSubmit"></report-info>
        </div>
        <span style="clear: both"></span>
        <el-button type="primary" size="mini" @click="editSubmitMonth" v-if="isShowMonthSubmit">{{ isMonthSubmit ? '月停止提报' : '月发起提报' }} </el-button>
        <el-button type="primary" size="mini" @click="isShowMonthImport = true" v-if="isMonthSubmit && isShowMonthImportBtn">月预估调整导入 </el-button>
        <el-button type="primary" size="mini" @click="editSwitchQuarter" v-if="isShowQuarterSubmit">{{ isQuarterSubmit ? '季度停止提报' : '季度发起提报' }} </el-button>
        <el-button type="primary" size="mini" @click="isShowQuarterImport = true" v-if="isQuarterSubmit && isShowQuarterImpotBtn">季度预估调整导入 </el-button>
        <el-button class="orange-btn"  size="mini" @click="isShowOvertimeImport = true" v-permission="'ec-pc-new$dataImport$preSalePlan$subMonthAdjust$timeoutImport'">预估超时导入 </el-button>
        <el-button type="primary" size="mini" @click="isShowExport = true">导出数据</el-button>
      </template>
    </import-task>
    <month-import :visible.sync="isShowMonthImport" v-if="isShowMonthImport" @success="handleSearch"/>
    <quarter-import :visible.sync="isShowQuarterImport" v-if="isShowQuarterImport" @success="handleSearch"/>
    <overtime-import :visible.sync="isShowOvertimeImport" v-if="isShowOvertimeImport"/>
    <overtime-import-records :visible.sync="isShowImportRecords" v-if="isShowImportRecords"/>
    <export-dialog :visible.sync="isShowExport" v-if="isShowExport" @export="handleExport"/>
  </div>
</template>

<script>
  import {getToken} from '@/utils/auth';
  import reportInfo from './report-info';
  import monthImport from './month-import'
  import quarterImport from './quarter-import'
  import overtimeImport from './overtime-import'
  import overtimeImportRecords from './overtime-import-records'
  import exportDialog from './export-dialog'
  import moment from 'moment';
  import { downloadFile } from '@/utils';

  export default {
  components: { reportInfo, monthImport, quarterImport, overtimeImport, overtimeImportRecords, exportDialog },
  data() {
    return {
      form: {
        startDate: '',
        endDate: '',
        endDateStr: '',
        reportName: '',
      },
      dialogFormVisible: false,
      isShowMonthImport: false,
      isShowQuarterImport: false,
      isShowOvertimeImport: false,
      isShowImportRecords: false,
      isShowExport: false,
      titleName: '',
      requestParam: {
        storeId: '',
      },
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      rules: {},
      fjLoading: false,
      stores: [],
      isMonthSubmit: false,
      isShowMonthSubmit: false,
      isQuarterSubmit: false,
      isShowQuarterSubmit: false,
    };
  },
  computed: {
    planTime() {
      return (moment().month() + 2 == 13 ? 1 : moment().month() + 2) + '月';
    },
    moment() {
      return moment().month() + 1 + '月';
    },
    isShowMonthImportBtn() {
      return moment().date() > 15;
    },
    isShowQuarterImpotBtn() {
      return moment().date() < 16;
    },
  },
  methods: {
    handleSearch() {
      console.log(this.$refs['importTask'].propList);
      this.form.endDate = this.form.endDateStr == null || this.form.endDateStr == '' ? this.form.endDateStr : this.form.endDateStr.substr(0, 10) + ' 23:59:59';
      this.$refs['importTask'].init(this.form);
    },
    // 根据月份获取店铺
    hanndlePlanTimeChange() {
      this.$q.preSalePlan
        .getMonthStore({
          params: {
            month: parseInt(this.requestParam.planTime),
          },
        })
        .then((res) => {
          if (res.code == 200) {
            console.log(res.data);
            this.stores = Object.keys(res.data).map((v) => {
              return {
                label: res.data[v],
                value: v,
              };
            });
            if (this.stores.length == 1) {
              this.requestParam.storeId = this.stores[0].value;
            }
          }
        });
    },
    getSwitchMonth() {
      this.$q.preSalePlan.switchGet({}).then((res) => {
        if (res.code == 200) {
          this.isMonthSubmit = res.data.switchStatus;
          this.isShowMonthSubmit = res.data.disableFlag;
        }
      });
    },
    editSubmitMonth() {
      this.$q.preSalePlan.switchModify({}).then((res) => {
        if (res.code == 200) {
          this.isMonthSubmit = res.data;
        }
      });
    },
    getSwitchQuarter() {
      this.$q.preSalePlan.switchQuarterGet({}).then((res) => {
        if (res.code == 200) {
          this.isQuarterSubmit = res.data.switchStatus;
          this.isShowQuarterSubmit = res.data.disableFlag;
        }
      });
    },
    editSwitchQuarter() {
      this.$q.preSalePlan.switchQuarterModify({}).then((res) => {
        if (res.code == 200) {
          this.isQuarterSubmit = res.data;
        }
      });
    },
    handleExport(data) {
      const loading = this.$loading({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.$q.preSalePlan.planAdjustExport({
        data,
        options: { responseType: 'blob' },
      }).then((blob) => {
        const fileName = `预估调整量-${data.planTime}-${data.storeCode}.xlsx`;
        downloadFile({
          data: blob,
          headers: {
            'content-disposition': `attachment;filename=${encodeURIComponent(fileName)}`,
          },
        });
      }).catch(() => {
        this.$message.error('导出失败');
      }).finally(() => {
        loading.close();
      });
    },
  },
  mounted() {
    this.form.reportName = 'prePlanGoodsAdjust';
    this.handleSearch();
    this.getSwitchMonth(); 
    this.getSwitchQuarter(); 
  },
};
</script>

<style lang="stylus" scoped>
.main-wrapper
  height calc(100vh - 65px)
.root
  padding 5px
>>> .el-header
  height: 39px !important
  margin-bottom: 5px
  padding 0
.btn-right
  float right
  line-height 24px
.btn-green
  cursor pointer
  color #0BB78E
  font-size 14px
  margin-right 10px
</style>
